import type { Router } from 'next/router';
import { useQuery } from 'react-query';
import type { AxiosResponse } from 'axios';

import { axiosInstance } from '@shared/lib/axios';
import type { TAxiosError } from '@shared/lib/types';
import { QUERIES_INFO } from '@shared/lib/const';

export const useGetUserJWT = (query: Router['query']) =>
  useQuery<AxiosResponse, TAxiosError, string>(
    QUERIES_INFO.getUserJwt.key,
    () => axiosInstance.get(QUERIES_INFO.getUserJwt.endpoint, { params: query }),
    { select: (response) => response?.request.responseURL },
  );
